module.exports = __webpack_public_path__ + "static/media/noOrder.53d6ae76.svg";